/**
 * Content someone else composed — the merchant panel's `WIDGET_PRINT` message. Port of web
 * `printHelper.js` `handlePrintData` (:709).
 *
 * The package lays out nothing here and checks nothing: the caller owns the content. The only rule
 * is where it goes — the master when this device is a slave, this device's printer otherwise.
 */
import type { Plan, PrintContext, RawInput } from "../types";
import { isEmpty } from "../util";

export function planRaw(input: RawInput, ctx: PrintContext): Plan {
  const printer = input.printer ?? ctx.printers.defaultPrinter ?? {};
  const relay = ctx.device.isSlave;
  if (!relay && isEmpty(printer)) return { pieces: [], skipped: [{ reason: "noDefaultPrinter" }] };
  if (!input.content) return { pieces: [], skipped: [] };
  return {
    pieces: [
      {
        document: "raw",
        destination: relay ? { to: "relay" } : { to: "printer", printer },
        copies: 1,
        source: { kind: "text", text: input.content },
      },
    ],
    skipped: [],
  };
}
